export default {
  sm: `
  DATA CENTER GAK, safely storing 
  NAVER's data, strives to provide 
  sustainable value to future industries.
  `,
  lg: `
  DATA CENTER GAK, safely storing NAVER's data, 
  strives to provide sustainable value to future industries.
  `,
  xxl: `
  DATA CENTER GAK, safely storing NAVER's data, strives to
  provide sustainable value to future industries.
  `,
};
